import {DocumentDataModel} from '../../../../models/document/document-data.model';

export class OrganizerOpenInImagingModel {
  folderId: string;
  documents: DocumentDataModel[];
}
